import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-layout-layout-4-blocks-icon',
  templateUrl: './layout-layout-4-blocks.component.html'
})
export class LayoutLayout4BlocksComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
